export const basisFooter = () => {
  const component: HTMLElement = document.querySelector('[is="basis-footer"]');

  /**
   * Make sure the year is up to date regardless of the cached version of the page
   */
  const handleYear = () => {
    const el: HTMLSpanElement = component.querySelector('.year');
    if (!el) return;
    el.innerText = new Date().getFullYear().toString();
  };

  handleYear();
};
